<template>
	<page id="top">
		<ZuiHeader />
		<!-- 景点介绍加map -->
		<div class="detailClass" :class="{map:map}">
			<div class="banner">
				<PageNavigater></PageNavigater>
				<cms-image :src="jjImg"></cms-image>
				<div class="mapPoint" v-if="map">
					<div class="star" :class="'star'+parseInt(index+1)" v-for="(slide,index) in swiperSlides"
						:key="index" @click="clickStar(index)">
						<div class="starMask">
							<div class="whiteStar"></div>
							{{ slide }}
						</div>
					</div>
				</div>
				<div class="mapTab" v-if="map">
					<swiper class="swiper" ref="mySwiper" :options="swiperOption" @click-slide="mapTab()">
						<swiper-slide class="map-tab-item" :class="{active:activeIndex==index}"
							v-for="(slide,index) in swiperSlides" :key="index">
							{{ slide }}</swiper-slide>
					</swiper>
					<div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>
				</div>
			</div>
			<div class="contain">
				<div class="content">
					<div class="title-bg"></div>
					<div class="bg">
						<div class="title">{{ swiperSlides[activeIndex] }}
							<div class="tuijianstar" v-if="tuijian">
								<span>推荐指数：</span>
								<el-rate v-model="star" :disabled="true"></el-rate>
								<div v-if="people" style="margin-left: 100px;">适宜人群：6~60岁</div>
							</div>
						</div>
						<div class="product" v-if="product">产品特色文字描述,包含主要景点、主要特色、打卡点、舒适度等相关内容的描述，文字内容不超过300字。产品特色文字描述,包含主要景点、主要特色、打卡点、舒适度等相关内容的描述:文字内容不超过30字。产品特色文字描述,包含主要景点、主要特色、打卡点、舒适度等相关内容的描述:文字内容不超过300字。产品待色文字描济包含主要景点、主要特色、打卡点、舒适度等相关内容的描述;文字内容不超过300字。</div>
						<div class="productInfo" v-if="product">温馨提示:行程中保护多个景点，需徒步抵达，请备好饮用水与实物...不超过两百字</div>
						<div class="richtext">123143</div>
						<!--<div class="article-content">
							<div class="article-pre">上一篇：峨眉雪芽与中茶开启合作</div>
							<div class="article-next">下一篇：峨眉雪芽禅茶文化艺术节大幕拉开</div>
						</div>-->
						<div class="reviewInformation"> 
							<div v-if="articleData.editor">编辑：{{articleData.editor	}}</div>
							<div v-if="articleData.executiveEditor">责任编辑：{{articleData.executiveEditor	}}</div>
							<div v-if="articleData.auditor">审核：{{articleData.auditor	}}</div>
						</div>
					</div>
				</div>
				<div class="about-article">
					<div class="about-article-title">相关文章</div>
					<div class="flex">
						<div class="about-article-item" v-for="item in 8" :key="item">
							<span>旅游婚礼季</span>
							<span>2023-10-10</span>
						</div>
					</div>
				</div>
				<!--<div class="detailButton1" v-if="showButton" @click="back()">
					<span>返回上级</span>
				</div>-->
				<div class="detailButton2" v-if="showButton" @click="toTop()">
					<span>回到顶部</span>
				</div>
			</div>
		</div>
		<ZuiFooter />
	</page>
</template>

<script>
  import {getArticle} from '~/api/CmsApi'
	import '~/views/less/detail.css'
	import Page from '~/components/Page'
	import ZuiHeader from '~/components/Header'
	import ZuiFooter from '~/components/Footer'
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css';
	export default {
		components: {
			Page,
			ZuiHeader,
			ZuiFooter,
			swiper,
			swiperSlide
		},
		data() {
			return {
				cmsImg: require('~/views/img/list/subImg/list-banner.jpg'),
				jjImg: require('~/views/img/list/subImg/jdjs-bg.jpg'),
				showButton: false,
				activeIndex: 0,
				star: 5,
				// <!-- 景点介绍加map=true -->
				map: false,
				// 推荐指数
				tuijian:true,
				// 适宜人群
				people:true,
				// 产品特色
				product:true,
				swiperOption: {
					slidesPerView: 9,
					centeredSlides: true,
					spaceBetween: 30,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					on: {
						click: () => {
							// 通过$refs获取对应的swiper对象
							let swiper = this.$refs.mySwiper.swiper;
							this.activeIndex = swiper.clickedIndex
							this.swiper.slideTo(swiper.clickedIndex, 1000, false)
						}
					},
				},
				swiperSlides: ['万佛顶', '金顶金佛', '接引殿', '洗象池', '华严顶', '仙峰寺', '九十九道拐', '万年寺', '生态猴区']
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper
			}
		},
		mounted: function() {
      this.getArticle(this.$route.query.id);
			this.$nextTick(function() {
				window.addEventListener('scroll', this.onScroll)
			})
		},
		methods: {
      getArticle(id) {
        getArticle(id).then(res => {
          console.log(res);
        })
      },
			onScroll() {
				let scrolled = document.documentElement.scrollTop || document.body.scrollTop // 586、1063分别为第二个和第三个锚点对应的距离
				if (scrolled > 300) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			},
			back() {
				this.$router.go(-1)
			},
			toTop() {
				document.getElementById('top').scrollIntoView({
					behavior: "smooth"
				});
			},
			mapTab(e) {
				console.log(e)
				console.log(this.swiper.realIndex)
				this.activeIndex = index
			},
			clickStar(index) {
				this.activeIndex = index
				this.swiper.slideTo(index, 1000, false)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/detail.vue